<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 2C20.5977 2 21.9037 3.24892 21.9949 4.82373L22 5V19C22 20.5977 20.7511 21.9037 19.1763 21.9949L19 22H5C3.40232 22 2.09634 20.7511 2.00509 19.1763L2 19V5C2 3.40232 3.24892 2.09634 4.82373 2.00509L5 2H19ZM11 4H5C4.48716 4 4.06449 4.49634 4.00673 5.13577L4 5.28571V11H5C5.55228 11 6 11.4477 6 12C6 12.5523 5.55228 13 5 13H4V19C4 19.5128 4.49634 19.9355 5.13577 19.9933L5.28571 20H11V19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19V20H19C19.5128 20 19.9355 19.614 19.9933 19.1166L20 19V13H19C18.4477 13 18 12.5523 18 12C18 11.4477 18.4477 11 19 11H20V5.28571C20 4.62635 19.5037 4.08292 18.8642 4.00865L18.7143 4H13V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V4ZM12 9C12.5128 9 12.9355 9.38604 12.9933 9.88338L13 10V11H14C14.5523 11 15 11.4477 15 12C15 12.5128 14.614 12.9355 14.1166 12.9933L14 13H13V14C13 14.5523 12.5523 15 12 15C11.4872 15 11.0645 14.614 11.0067 14.1166L11 14V13H10C9.44772 13 9 12.5523 9 12C9 11.4872 9.38604 11.0645 9.88338 11.0067L10 11H11V10C11 9.44772 11.4477 9 12 9Z"
    fill="currentColor"
  />
</svg>
